import { NativeTranslations } from '@repo/types';
import { getBilberryLanguageFromLocale } from '@repo/widget-utils/services/utils/api-client-common';

// Resolves a Base translations map ({ en: '…', nb: '…' }) for the current locale,
// falling back to English, then any available translation, then empty.
export function resolveNativeText(
    map: NativeTranslations | null | undefined,
    locale: string,
): string {
    if (!map) return '';
    const lang = getBilberryLanguageFromLocale(locale);
    return map[lang] ?? map.en ?? Object.values(map)[0] ?? '';
}
